import { useEffect, useState } from "react";
import { Sun, CloudSun, Cloud, CloudFog, CloudDrizzle, CloudRain, CloudSnow, CloudLightning } from "lucide-react";

export const decodeWeather = (code) => {
  if (code === 0) return { Icon: Sun, en: "Clear", ar: "صحو", tone: "bg-yellow-400" };
  if (code === 1) return { Icon: Sun, en: "Mostly clear", ar: "صحو غالباً", tone: "bg-yellow-400" };
  if (code === 2) return { Icon: CloudSun, en: "Partly cloudy", ar: "غائم جزئياً", tone: "bg-slate-400" };
  if (code === 3) return { Icon: Cloud, en: "Overcast", ar: "غائم", tone: "bg-slate-500" };
  if (code === 45 || code === 48) return { Icon: CloudFog, en: "Fog", ar: "ضباب", tone: "bg-slate-400" };
  if (code >= 51 && code <= 57) return { Icon: CloudDrizzle, en: "Drizzle", ar: "رذاذ", tone: "bg-sky-500" };
  if ((code >= 61 && code <= 67) || (code >= 80 && code <= 82)) return { Icon: CloudRain, en: "Rain", ar: "مطر", tone: "bg-blue-600" };
  if ((code >= 71 && code <= 77) || (code >= 85 && code <= 86)) return { Icon: CloudSnow, en: "Snow", ar: "ثلج", tone: "bg-sky-400" };
  if (code >= 95) return { Icon: CloudLightning, en: "Thunder", ar: "عاصفة", tone: "bg-purple-700" };
  return { Icon: Sun, en: "Clear", ar: "صحو", tone: "bg-yellow-400" };
};

const DUBAI = { lat: 25.276987, lon: 55.296249 };
const KEY = "wx_v1"; const TTL = 15 * 60 * 1000; // 15 min cache

function readCache() {
  try {
    const raw = localStorage.getItem(KEY); if (!raw) return null;
    const { t, d } = JSON.parse(raw);
    return Date.now() - t < TTL ? d : null;
  } catch { return null; }
}

async function fetchWx(lat, lon) {
  const url = `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&current=temperature_2m,apparent_temperature,relative_humidity_2m,wind_speed_10m,weather_code,uv_index&daily=sunrise,sunset,temperature_2m_max,temperature_2m_min&timezone=auto&forecast_days=1`;
  const j = await (await fetch(url)).json();
  return {
    temp: Math.round(j.current?.temperature_2m ?? 0),
    feels: Math.round(j.current?.apparent_temperature ?? 0),
    humidity: Math.round(j.current?.relative_humidity_2m ?? 0),
    wind: Math.round(j.current?.wind_speed_10m ?? 0),
    uv: Math.round((j.current?.uv_index ?? 0) * 10) / 10,
    code: j.current?.weather_code ?? 0,
    hi: Math.round(j.daily?.temperature_2m_max?.[0] ?? 0),
    lo: Math.round(j.daily?.temperature_2m_min?.[0] ?? 0),
    sunrise: j.daily?.sunrise?.[0], sunset: j.daily?.sunset?.[0],
  };
}

export function useWeather() {
  const [data, setData] = useState(() => readCache());
  useEffect(() => {
    const load = async (lat, lon) => {
      try {
        const d = await fetchWx(lat, lon);
        setData(d);
        try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d })); } catch { /* silent */ }
      } catch { /* silent */ }
    };
    if (data) { load(DUBAI.lat, DUBAI.lon); return; } // background refresh
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (p) => load(p.coords.latitude, p.coords.longitude),
        () => load(DUBAI.lat, DUBAI.lon),
        { timeout: 3000, maximumAge: 1800000 },
      );
    } else load(DUBAI.lat, DUBAI.lon);
  }, []);
  return data;
}
